export default [
  {
    path: "/split-expenses/new",
    name: "split-expenses-create",
    meta: {
      title: "Амортизационный расход",
      authRequired: true,
    },
    component: () => import("@/modules/split-expenses/views/edit.vue"),
  },
];
